module.exports = __webpack_public_path__ + "static/media/lmm-logo.3be85480.png";